<script setup lang="ts"></script>

<template>
  <div>
    <div
      class="lazy-loading mb-2 rounded-md"
      style="width: 80%; height: 20px"
    />
    <div class="lazy-loading rounded-md" style="width: 50%; height: 20px" />
  </div>
</template>
